import styled from 'styled-components';

export const GlobalCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: auto;
  margin-bottom: 20px;
  border-radius: 10px;
  background-color: var(--bottom-color-sefaz);
  box-shadow: 0 2px 6px rgb(0 0 0 / 16%);
  padding: 20px;
  padding-bottom: 30px;
`;

export const GlobalContainerReferencia = styled.div`
  width: 50%;
  margin: auto;
`;

export const GlobalReferencia = styled.a`
  font-size: 6.5pt;
  display: block;
  text-align: right;
  margin-right: ${props => props.margin};
`;

export const GlobalErro = styled.p`
  margin-left: 2px;
  color: #d40d27 !important;
`;

export const Label = styled.p`
  margin: 10px 10px 20px 0px;
`;

export const GlobalButtonContain = styled.div`
  display: ${props => props.display || 'flex'};
  flex-direction: ${props => props.flexDirection || 'row'};
  align-items: ${props => props.alignItems};
  justify-content: ${props => props.justifyContent};
  .ant-btn {
    color: ${props => props.corSecundaria || '#ffffff'};
    border-color: ${props => props.cor || '#0681dd'};
    background-color: ${props => props.cor || '#0681dd'};
  }
  .ant-btn:hover {
    color: ${props => props.cor || '#0681dd'};
    border-color: ${props => props.cor || '#0681dd'};
    background-color: ${props => props.corSecundaria || '#ffffff'};
  }
`;
